<template>
  <template
    v-for="(item, index) in items"
    :key="item.id"
  >
    <SubRenderingProvider
      :fields="item.fields"
      :data-source="item.id"
    >
      <slot
        :item="item"
        :index="index"
        :fields="item.fields"
      />
    </SubRenderingProvider>
  </template>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';

import SubRenderingProvider from './SubRenderingProvider.vue';

defineOptions({ name: 'MultiDataSourceProviderFi' });

export interface SubRendering {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: Record<string, any>;
}

const props = defineProps<{
  fieldName: string;
}>();

const fields = inject<Record<string, any>>('fields');

const items = computed<SubRendering[]>(() => {
  if (!fields || !props.fieldName || !(props.fieldName in fields)) {
    return [];
  }
  const value = fields[props.fieldName];
  return Array.isArray(value) ? value : [];
});
</script>
